import create from 'zustand';

import { SubscriptionStore } from './type';

const useSubscriptionStore = create<SubscriptionStore>()((set, get) => ({
  status: 'valid',
  setStatus: (to) => {
    const store = get();
    if (store.status === 'dismissed' && to === 'expiring') {
      return;
    }
    set({ status: to });
  }
}));

export default useSubscriptionStore;
